import { render, staticRenderFns } from "./performanceCapability.vue?vue&type=template&id=3da475f5&scoped=true&"
import script from "./performanceCapability.vue?vue&type=script&lang=js&"
export * from "./performanceCapability.vue?vue&type=script&lang=js&"
import style0 from "./performanceCapability.vue?vue&type=style&index=0&id=3da475f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da475f5",
  null
  
)

export default component.exports